let loadPromise = null;
let cachedEngine = null;

export function isEngineLoaded() {
    return cachedEngine !== null;
}

export function isEngineLoading() {
    return loadPromise !== null && cachedEngine === null;
}

export function beginEngineLoad() {
    return loadEngine();
}

export function loadEngine() {
    if (cachedEngine) {
        return Promise.resolve(cachedEngine);
    }

    if (!loadPromise) {
        loadPromise = import(/* webpackChunkName: "image-engine" */ './engineBundle')
            .then((module) => {
                cachedEngine = module;
                return module;
            })
            .catch((error) => {
                loadPromise = null;
                throw error;
            });
    }

    return loadPromise;
}
